<app-command [command]="action$" (success)="complete()">
  <div class="dialog">

      <div class="dialog__title">
        {{ title }}
      </div>

      <ng-container *appLoad="let messages of messages$">
        <div class="dialog__message" *ngFor="let message of messages">
          <pre *ngIf="preformatted" style="text-align: left">{{ message }}</pre>
          <ng-container *ngIf="!preformatted">{{ message }}</ng-container>
        </div>
      </ng-container>

      <div class="dialog__actions">

        <ng-container *ngFor="let button of buttons">
          <lds-button
            [appearance]="getAppearance(button.colour)"
            (onClick)="setComplete(button.complete); triggerAction(button.action)">
              {{ button.label }}
          </lds-button>
        </ng-container>

      </div>
  </div>
</app-command>
